<template>

    <div ref="senderContainer" class="senders-container">


    </div>

</template>

<script>

export default {

    name: 'scrolling-senders',

    props: {

        sender: {
            type: String,
            default: ''
        }
    },

    watch: {

        sender: function (sender) {

            if (sender) {

                this.addSender(sender)

            }

        }

    },

    data() {
        return {}
    },

    methods: {

        addSender(sender) {

            const html = document.createElement('div')
            html.className = 'anim-sender-scroll sender-text'
            html.append(sender)

            this.$refs.senderContainer.prepend(html)

        }

    }

}

</script>

<style lang="scss">


.anim-sender-scroll {
    animation: anim-scroll 2s 1 ease-out normal;
    opacity: 0;
}

div.anim-sender-scroll:nth-child(1) {
    opacity: 1
}

;
div.anim-sender-scroll:nth-child(2) {
    opacity: 0.8
}

;
div.anim-sender-scroll:nth-child(3) {
    opacity: 0.6
}

;
div.anim-sender-scroll:nth-child(4) {
    opacity: 0.4
}

;
div.anim-sender-scroll:nth-child(5) {
    opacity: 0.2
}

;

@keyframes anim-scroll {
    0% {
        opacity: 0;
        height: 0;
    }

    10% {
        opacity: 0;
        height: 20px;
    }

    20% {
        opacity: 1;
        height: 20px;
    }

    100% {
        opacity: 1;
        height: 20px;
    }
}

</style>

<style lang="scss" scoped>

.sender-text {
    font-size: 11px;
    line-height: 1.45;
    overflow: hidden;
    height: 100px;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 15px;
        font-weight: 500;
        line-height: 1.33;
    }
}

.senders-container {
    overflow: hidden;
    margin: 29px 0 35px;
    height: 100px;
    flex-direction: column-reverse;
}

</style>
